import { UPDATE_ACTIVE_LANGUAGE, UPDATE_CURRENT_PAGE, UPDATE_ERROR_STATUS, UPDATE_GENERIC_IMAGES, UPDATE_GROUP_STATUS, UPDATE_GUEST_MEMBERSHIPS, UPDATE_GUEST_PACKAGES, UPDATE_ITEM_STOCK, UPDATE_LANGUAGE_KEYWORDS, UPDATE_LOADER_STATUS, UPDATE_PDP_ITEM, UPDATE_PDP_ITEM_STATUS, UPDATE_REDEEMABLES_LIST, UPDATE_SEARCH_STATUS, UPDATE_SHOW_SERVICES_CART, UPDATE_STORES_LIST, UPDATE_WHATSAPP_TEMPLATES } from "@constant/common";

export const updateGroupStatus = (payload) => {
    return { type: UPDATE_GROUP_STATUS, payload };
}

export const updateGenericImages = (payload) => {
    return { type: UPDATE_GENERIC_IMAGES, payload };
}

export const updateCurrentPage = (payload) => {
    return { type: UPDATE_CURRENT_PAGE, payload };
}

export const updatePdpItem = (payload) => {
    return { type: UPDATE_PDP_ITEM, payload };
}

export const updatePdpItemStatus = (payload) => {
    return { type: UPDATE_PDP_ITEM_STATUS, payload };
}

export const enableLoader = (payload = true) => {
    return { type: UPDATE_LOADER_STATUS, payload };
}

export const disableLoader = (payload = false) => {
    return { type: UPDATE_LOADER_STATUS, payload };
}

export const updateSearchStatus = (payload) => {
    return { type: UPDATE_SEARCH_STATUS, payload };
}

export const updateErrorStatus = (payload) => {
    return { type: UPDATE_ERROR_STATUS, payload };
}

export const updateWhatsappTemplates = (payload) => {
    return { type: UPDATE_WHATSAPP_TEMPLATES, payload };
}

export const updateItemStock = (payload) => {
    return { type: UPDATE_ITEM_STOCK, payload };
}

export const showServicesCart = (payload) => {
    return { type: UPDATE_SHOW_SERVICES_CART, payload };
}

export const updateStoresList = (payload) => {
    return { type: UPDATE_STORES_LIST, payload };
}

export const updateLanguageKeywords = (payload) => {
    return { type: UPDATE_LANGUAGE_KEYWORDS, payload };
}

export const updateActiveLanguage = (payload) => {
    return { type: UPDATE_ACTIVE_LANGUAGE, payload };
}

export const updateRedeemablesList = (payload) => {
    return { type: UPDATE_REDEEMABLES_LIST, payload };
}

export const updateGuestMemberships = (payload) => {
    return { type: UPDATE_GUEST_MEMBERSHIPS, payload };
}

export const updateGuestPackages = (payload) => {
    return { type: UPDATE_GUEST_PACKAGES, payload };
}
